module.exports = __webpack_public_path__ + "static/Qasim-ea7b38f36a6fb35b1786b2937b8fc9b1.jpg";